// extracted by mini-css-extract-plugin
export var container = "_ck-0";
export var popoverContent = "_ck-1";
export var tosLink = "_ck-2";